import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  radius?: string;
  className?: string;
}

/**
 * Bloque con shimmer que ocupa el sitio del contenido mientras carga.
 * `minWidth` acompaña a `width` para poder pintar piezas mas estrechas que el
 * minimo por defecto (avatares, badges) sin que el CSS base las ensanche.
 */
export const Skeleton: React.FC<SkeletonProps> = ({ width, height, radius, className = '' }) => (
  <div
    className={`al-skeleton ${className}`}
    style={{ width, height, minWidth: width, borderRadius: radius }}
    aria-hidden="true"
  />
);
